<template>
  <div class="productnew">
    <!--banner-->
    <div class="banner outer">
      <div class="inside1490">
         <h1 class="banner_title">易猎云招聘管理系统
          <span class="banner_rpo">HR版</span>
         </h1>
         <p class="banner_txt">专注为企业HR解决招聘难、成本高、人才流失大<br/>等问题，提供渠道整合管理、人才库搭建、多端<br/>招聘协同、招聘数据分析全流程服务</p>
      </div>
    </div>
    <!--全流程数字化管理-->
    <div class="process outer">
      <div class="inside1490">
        <h2>招聘全流程数字化管理</h2>
        <div class="serviceProcessChart">
          <ul class="cl">
            <li v-for="(yu, index) in serviceProcessChartList" :key="index">
              <h3><img :src="yu.serviceProcessChartimg"/></h3>
              <p>{{ yu.serviceProcessCharttext }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--图片文字排版1-->
    <div class="outer">
      <div class="inside1490 textimgbox" style="height: 550px;">
        <img
          class="fl"
          style="width: 541px;height: 364px;margin-top: 94px;margin-left: 65px;"
          src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/hr2_pic_01%402x.png"
        />
        <div class="fr" style="margin-right: 127px;">
          <h2 style="text-align: left;">HR体验更友好的招聘系统</h2>
          <p class="text_detail" style="width: 520px;">专为HR招聘场景设计，不改变HR的工作习惯<br/> 简历自动入库，支持简历查重、简历匹配度展示<br/> 在招聘平台上完成工作内容，无需频繁切换系统</p>
        </div>
      </div>
    </div>
    <!--清除浮动-->
    <div class="clear"></div>
    <!--文字图片排版2-->
    <div class="outer">
      <div class="inside1490 imgtextbox" style="height: 580px;">
        <div class="fl" style="margin-left: 134px;">
          <h2 style="text-align: left">多渠道简历统一管理</h2>
          <p class="text_detail">支持主流招聘平台简历入库<br/> 支持内外部推荐以及渠道交付<br/> 多格式的简历一站汇总，精准判重</p>
        </div>
        <img
          class="fr"
          style="width: 399px;height: 387px;margin-top: 120px;margin-right: 191px;"
          src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/hr2_pic_02%402x.png"
        />
      </div>
    </div>
    <!--清除浮动-->
    <div class="clear"></div>
     <!--图片文字排版3-->
     <div class="outer">
      <div class="inside1490 textimgbox" style="height: 590px;">
        <img
          class="fl"
          style="width: 500px;height: 490px;margin-top: 42px;margin-left: 70px"
          src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/hr2_pic_03%402x.png"
        />
        <div class="fr" style="margin-right: 173px;">
          <h2 style="text-align: left;">创新的自激活人才库</h2>
          <p class="text_detail" style="width: 460px;">自研简历解析与OCR引擎，精准识别简历<br/> 人才库简历的自动激活，帮助企业节省成本<br/> 自定义标签设置，灵活复用简历</p>
        </div>
      </div>
    </div>
    <!--清除浮动-->
    <div class="clear"></div>
     <!--文字图片排版4-->
     <div class="outer">
      <div class="inside1490 imgtextbox" style="height: 602px;">
        <div class="fl" style="margin-left: 134px;">
          <h2 style="text-align: left">灵活的面试管理</h2>
          <p class="text_detail" style="width: 650px;">统筹多场次面试安排，HR、面试官、候选人之间高效协同<br/>实时同步面试结果、面试评价，提升沟通效率和招聘体验<br/>招聘全流程数据分析</p>
        </div>
        <img
          class="fr"
          style="width: 500px;height: 397px;margin-top: 114px;margin-right: 65px"
          src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/hr2_pic_04%402x.png"
        />
      </div>
    </div>
    <!--清除浮动-->
    <div class="clear"></div>
    <!--图片文字排版5-->
    <div class="outer">
      <div class="inside1490 textimgbox" style="height: 580px;">
        <img
          class="fl"
          style="width: 633px;height: 383px;margin-top: 84px;margin-left: 59px;"
          src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/hr2_pic_05%402x.png"
        />
        <div class="fr" style="margin-right: 196px;">
          <h2 style="text-align: left;">卓越的系统打通能力</h2>
          <p class="text_detail" style="width: 440px;">支持对接通讯外呼线路，一键外呼及录音<br/> 工作手机、个人微信、企业微信打通<br/> 开放系统API，自由对接内部系统</p>
        </div>
      </div>
    </div>
    <!--清除浮动-->
    <div class="clear"></div>
    <!--文字图片排版6-->
    <div class="outer">
      <div class="inside1490 imgtextbox" style="height: 580px;">
        <div class="fl" style="margin-left: 134px;">
          <h2 style="text-align: left">企业内推场景支持</h2>
          <p class="text_detail" style="width: 350px;">支持移动端招聘门户展示<br/> 微信分享岗位，支持简历内推<br/> 岗位裂变、内推成果数据分析</p>
        </div>
        <img
          class="fr"
          style="width: 456px;height: 424px;margin-top: 93px;margin-right: 164px;"
          src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/hr2_pic_06%402x.png"
        />
      </div>
    </div>
    <!--清除浮动-->
    <div class="clear"></div>
        <!--图片文字排版7-->
        <div class="outer">
      <div class="inside1490 textimgbox" style="height: 580px;">
        <img
          class="fl"
          style="width: 406px;height: 355px;margin-top: 73px;margin-left: 199px;"
          src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/hr2_pic_07%402x.png"
        />
        <div class="fr" style="margin-right: 39px;">
          <h2 style="text-align: left;">多端招聘协同</h2>
          <p class="text_detail" style="width: 610px;">HR、用人经理、管理者、猎头等多角色协同办公<br/> 支持移动端办公，随时随地高效工作<br/> 支持API对接，支持与eHR、OA等现有办公系统高度兼容 </p>
        </div>
      </div>
    </div>
    <!--清除浮动-->
    <div class="clear"></div>
    <div class="security outer">
          <div class="inside1490 security_child">
            <div class="security_left"><img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_customer_service%402x.png"/></div>
            <div class="security_right">
              <p class="p1">即刻开启数字化招聘人效提升之旅</p>
              <!-- <div class="security_center" @click="trial()">申请试用</div> -->
            </div>
           
          </div>
      </div>
      <!--申请试用组件-->
    <populone v-if="windowflags" :isshow="windowflags" :selectId="''" :he="true" @handleChange="changewindows" />
  </div>
</template>
<script>
import populone from "@/components/views/popul/populone";
export default {
  name: "productnew",
  data() {
    return {
      windowflags:false,
      routeData:{},
      serviceProcessChartList: [
        {
          serviceProcessCharttext: "职位发布",
          serviceProcessChartimg:
            "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/hr_icon_job_posting%402x.png",
        },
        {
          serviceProcessCharttext: "初筛",
          serviceProcessChartimg:
            "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/hr_icon_preliminary_screening%402x.png",
        },
        {
          serviceProcessCharttext: "用人部门筛选",
          serviceProcessChartimg:
            "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/hr_icon_departmental_screening%402x.png",
        },
        {
          serviceProcessCharttext: "面试",
          serviceProcessChartimg:
            "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/hr_icon_interview%402x.png",
        },
        {
          serviceProcessCharttext: "Offer",
          serviceProcessChartimg:
            "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/hr_icon_offer%402x.png",
        },
        {
          serviceProcessCharttext: "入职",
          serviceProcessChartimg:
            "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/hr_icon_entry%402x.png",
        },
      ],
      type:1
    };
  },
  components: {
        populone,
  },
  mounted(){
  //   this.type= this.$route.params.id;
  //   console.log(this.type,'路由的值');
    if (Object.keys(this.$route.query).length) {
      this.routeData = this.$route.query;
    }
    const { u = "" } = this.routeData;
    if (!u) {
      console.log("WWWW");
      zhuge.track("官网产品页", {
        渠道: "pc",
        utm类型: "自然流量",
      });
    } else {
      zhuge.track("官网产品页", {
        渠道: "pc",
        utm类型: "驱动流量",
      });
    }
  },
  metaInfo: {
      title: '易猎云招聘管理系统HR版-免费的企业招聘管理系统',
      meta: [
        {
          name: 'keywords',
          content: '招聘管理系统，简历库系统，企业招聘人事系统，人才激活，ATS'
        },
        {
          name: 'description',
          content: '易猎云招聘管理系统HR版是专为专业HR团队设计的一站式的数字化招聘平台，系统化的解决企业人才库搭建困难，招聘效率低，招聘平台及交付渠道简历整合困难等难题，创新的人才库激活能力帮助企业降低招聘成本。'
        }
      ]
  },
  methods:{
    trial(){
      this.windowflags = true;
      },
      changewindows(value) {
        this.windowflags = value;
      },
  }
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
.productnew {
  margin-top: 85px;
  .banner {
    width: 100%;
    height: 730px;
    background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/banner3%402x.png');
    background-repeat: no-repeat;
    background-size: 100%;
    padding-top: 230px;
    box-sizing: border-box;
    .banner_title{
      font-size: 60px;
      color: #1D2754;
      line-height: 112px;
    }
    .banner_rpo{
        display: inline-block;
        width: 80px;
        height: 34px;
        border-radius: 7px;
        border: 1px solid #5666FF;
        font-size: 20px;
        color: #5666FF;
        line-height: 34px;
        text-align: center;
        vertical-align: top;
        margin-top: 30px;
      }
    .banner_txt{
      font-size: 24px;
      color: #3A4D70;
      line-height: 40px;
    }
  }
  .process {
    width: 100%;
    height: 523px;
    background: #F2F5FB;
    padding-top: 79px;
    box-sizing: border-box;
    h2 {
      font-size: 48px;
      color: #1D2754;
      line-height: 48px;
      text-align: center;
    }
    .serviceProcessChart {
      ul {
        padding-top: 61px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        margin-left: 60px;
        li {
          width: 176px;
          height: 248px;
          background-color: #ffffff;
          border-radius: 10px;
          float: left;
          position: relative;
          h3 {
            width: 65px;
            height: 65px;
            background-color: #f8fafe;
            margin: 0 auto;
            margin-top: 46px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          p {
            text-align: center;
            margin-top: 52px;
            font-size: 22px;
            letter-spacing: -1px;
            color: #1d2754;
            line-height: 29px;
          }
        }
        li:last-child {
          margin-right: 0px;
        }
        li:after {
          content: "";
          position: absolute;
          display: inline-block;
          width: 47px;
          height: 19px;
          background-image: url("https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mk_arrow_to_right.gif");
          background-repeat: no-repeat;
          background-size: 100%;
          right: -55px;
          top: 50%;
          transform: translateY(-50%);
        }
        li:last-child:after {
          content: "";
          width: 0;
          height: 0;
          border: 0;
        }
      }
    }
  }
  .textimgbox {
    width: 1490px;
    height: 610px;
    border-bottom: solid 1px #E4E6EE;
    h2 {
      font-size: 42px;
      margin-top: 126px;
      font-weight: 500;
      color: #1d2754;
      line-height: 48px;
    }
    .text_detail{
      width: 453px;
      font-size: 24px;
      color: #7087A6;
      line-height: 42px;
      margin-top: 31px;
    }
  }
  .clear {
    clear: both;
  }
  .imgtextbox {
    width: 1490px;
    height: 610px;
    border-bottom: solid 1px #E4E6EE;
    h2 {
      font-size: 42px;
      margin-top: 120px;
      font-weight: 500;
      color: #1d2754;
      line-height: 48px;
    }
    .text_detail{
      width: 408px;
      font-size: 24px;
      color: #7087A6;
      line-height: 42px;
      margin-top: 31px;
    }
  }
  .security{
      width: 100%;
      height: 277px;
      background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/bg_01%402x.png');
      background-repeat: no-repeat;
      background-size: 100% 102%;
      padding-top: 53px;
      box-sizing: border-box;
      .security_child{
        display: flex;
        .security_left{
            margin-left: 197px;
              img{
                width: 145px;
                height: 128px;
              }
        }
        .security_right{
             margin-left: 37px;
              .p1{
              display: inline-block;
              font-size: 48px;
              font-weight: 500;
              color: #ffffff;
              text-align: left;
              margin-top: 47px;
          }
        }
        .security_center{
          width: 158px;
          height: 60px;
          background: #FFFFFF;
          border-radius: 7px;
          line-height: 60px;
          text-align: center;
          font-size: 24px;
          color: #215FFF;
          cursor: pointer;
          margin: 0 auto;
          margin-top: 40px;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/product/producthr.vue